import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { loginRequest } from './auth/msal';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Explorer } from './pages/Explorer';
import { Acl } from './pages/Acl';
import { Agents } from './pages/Agents';
import { Automations } from './pages/Automations';
import { AutomationDetail } from './pages/AutomationDetail';
import { McpConsent } from './pages/McpConsent';
import { Users } from './pages/Users';
import logoBig from './logo_big.png';

export default function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const { pathname } = useLocation();

  // An agent's sign-in lands here from /oauth/authorize. The page runs its own Microsoft
  // sign-in and stands alone, without the admin navigation.
  if (pathname === '/mcp/consent') return <McpConsent />;

  if (!isAuthenticated) {
    return (
      <div className="flex h-full flex-col items-center justify-center bg-[#162866]">
        <img
          src={logoBig}
          alt="FABS — Fantastically Awesome Blob Storage"
          className="mb-8 w-80 max-w-[80%]"
        />
        <button
          className="rounded bg-white px-5 py-2 font-semibold text-[#162866] hover:bg-white/90"
          onClick={() => void instance.loginRedirect(loginRequest)}
        >
          Sign in with Microsoft
        </button>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/explorer" element={<Explorer />} />
        <Route path="/acl" element={<Acl />} />
        <Route path="/automations" element={<Automations />} />
        <Route path="/automations/:id" element={<AutomationDetail />} />
        <Route path="/users" element={<Users />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}
